module.exports = __webpack_public_path__ + "img/album19_02.50e6c303.jpg";